import React, { useEffect, useState } from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import styles from "./krpano.scss";
import { useLocation, useParams, useHistory } from "react-router";
import request from "../../common/request";
import Modal from "react-modal";
import { useCookies } from "react-cookie";
import { includes } from "lodash";
import { getSessionItem, setSessionItem } from "../../common/helpers";

function lerp(a, b, alpha) {
    return a + alpha * (b - a);
}

function calculateElementHeight(htmlString, maxWidth) {
    let height = 336;

    const container = document.createElement("div");
    container.style.width = `${maxWidth}px`;
    container.insertAdjacentHTML("beforeend", htmlString);
    document.body.appendChild(container);
    height = container.getBoundingClientRect().height;
    container.remove();

    return height;
}

const Krpano = ({ isEmbed, vtOnly }) => {
    const [cookies, setCookie, removeCookie] = useCookies(["panoHelp"]);
    const location = useLocation();
    const params = useParams();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [vtour, setVtour] = useState(null);
    const [panos, setPanos] = useState([]);
    const [activePano, setActivePano] = useState(null);
    const [activePanoIndex, setActivePanoIndex] = useState(1);
    const [isWebVRCapable, setIsWebVRCapable] = useState(false);
    const [webVRActive, setWebVRActive] = useState(false);
    const [thumbNavOpened, setThumbNavOpened] = useState(false);
    const [infoModalOpened, setInfoModalOpened] = useState(false);
    const [infoSmallModalOpened, setInfoSmallModalOpened] = useState(false);
    const [jobModalOpened, setJobModalOpened] = useState(false);
    const [videoModalOpened, setVideoModalOpened] = useState(false);
    const [panoModalOpened, setPanoModalOpened] = useState(false);
    const [showPanoTitle, setShowPanoTitle] = useState(true);
    const [showPanoNavTitle, setShowPanoNavTitle] = useState(null);
    const [showPanoHelp, setShowPanoHelp] = useState(false);

    const [panoData, setPanoData] = useState(null);
    const [hotspotData, setHotspotData] = useState(null);

    const [thumbSwiper, updateThumbSwiper] = useState(null);
    const [visitedHotspots, setVisitedHotspots] = useState(getSessionItem("visitedHotspots"));

    const thumbNavSiderParams = {
        slidesPerView: "auto",
        containerClass: styles.thumbNavSlider__container,
        // activeSlideKey: activePanoIndex,
        // shouldSwiperUpdate: true,
        // rebuildOnUpdate: true,
        // simulateTouch: false,
        spaceBetween: 30,
        grabCursor: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        renderPrevButton: () => (
            <button
                className={[
                    "swiper-button-prev",
                    styles.thumbNavSlider__button,
                    styles.thumbNavSlider__button__prev,
                ].join(" ")}
            />
        ),
        renderNextButton: () => (
            <button
                className={[
                    "swiper-button-next",
                    styles.thumbNavSlider__button,
                    styles.thumbNavSlider__button__next,
                ].join(" ")}
            />
        ),
        on: {
            init: function () {
                // console.log('swiper initialized', activePanoIndex);
                // console.log('swiper initialized', thumbSwiper, activePanoIndex);
                // if( thumbSwiper ) {
                //     thumbSwiper.slideTo(  findIndex(panos, pano) );
                // }
            },
        },
    };

    // useEffect(() => {

    // }, []);

    useEffect(() => {
        async function process() {
            if (vtour == null || (vtour !== null && vtour.slug != params.tour)) {
                var tourData = await loadTourData();
            }
            if (!activePano || activePano.slug != params.panorama) {
                let nextPano = find(panos, ["slug", params.panorama]);
                if (
                    (nextPano && !activePano) ||
                    (nextPano && activePano && nextPano.id !== activePano.id)
                ) {
                    loadpano(null, nextPano.id);
                }
            }
        }

        if (params.tour) {
            process();
        }
    }, [location]);

    // CHECK VISITED HOTSPOT CHANGES
    useEffect(() => {
        setSessionItem("visitedHotspots", visitedHotspots);
    }, [visitedHotspots]);

    //VIRTUAL TOUR
    const loadTourData = async () => {
        setLoading(true);

        var result = await request
            .get("/api/virtual-tour/data")
            .query({
                slug: params.tour,
            })
            .set("Accept", "application/json, text/javascript");

        setLoading(false);
        setVtour(result.body.tour);
        setPanos(result.body.panos);

        var initialPano = null;
        if (!params.panorama) {
            initialPano = result.body.panos[0];
        } else {
            let currPano = find(result.body.panos, ["slug", params.panorama]);
            if (currPano) {
                initialPano = currPano;
            }
        }

        if (initialPano) {
            initTour(result.body.tour.id, initialPano.id);
            history.replace({
                pathname:
                    (isEmbed ? "/embed" : "") +
                    `/virtual-tour/${result.body.tour.slug}/${initialPano.slug}`,
                search: location.search,
            });
        }
    };

    const initTour = async (id, panoId) => {
        var xml = "/xml/tour?id=" + id + "&ver=" + new Date().getTime();
        let { embedpano } = window;

        // var panodata = await loadPanoData(panoId);

        embedpano({
            xml: xml,
            target: "krpano",
            html5: "only",
            mobilescale: 1.0,
            wmode: "opaque",
            passQueryParameters: true,
            consolelog: true,
            webxr: "prefer",
            onready(krpano) {
                window.krpanoObj = krpano.get("global");

                window.krpanoObj.control.mouse = "follow";
                window.krpanoObj.control.touch = "follow";

                window.krpanoObj.cursors.standard = "grab";
                window.krpanoObj.cursors.dragging = "grabbing";
                window.krpanoObj.cursors.moving = "grabbing";

                // window.krpanoObj.view.fov = 120;
                // window.krpanoObj.view.fovtype = "mfov";
                // window.krpanoObj.view.maxpixelzoom = 1.0;
                // window.krpanoObj.view.fovmax = 120;
                // window.krpanoObj.view.limitview = 'auto';

                setShowPanoTitle(true);

                if (cookies.panoHelp !== "1") {
                    setShowPanoHelp(true);
                } else {
                    setShowPanoHelp(false);
                }
            },
            initvars: {
                basePath: "/krpano-1.20.11",
                partialPath: "/krpano-1.20.11/partials",
                pluginPath: "/krpano-1.20.11/plugins",
                assetPath: "/krpano-1.20.11/assets",
            },
        });
    };
    //

    // GENERIC ACTIONS
    window.handleHotspotClick = (type, id, name) => {
        // console.log(type, id, name);
        const clickedHotspot = window.krpanoObj.get(`hotspot[${name}]`);
        if (type != "exit_vr" && type != "next_vr" && type != "prev_vr") {
            updateVisitedHotspots(type, id, name.replace("_text", "_hitarea"));
        }

        switch (type) {
            case "navigateTo":
                loadpano(null, id);
                break;
            case "information":
                window.krpanoObj.call(
                    "info_set_as_visited('" + name.replace("_text", "_hitarea") + "');"
                );
                if (!webVRActive) handleOpenInfoModal(id);
                else handleOpenVrInfoModal(id, clickedHotspot);
                break;
            case "informationSmall":
                window.krpanoObj.call(
                    "info_set_as_visited('" + name.replace("_text", "_hitarea") + "');"
                );
                if (!webVRActive) handleOpenInfoSmallModal(id);
                else handleOpenVrInfoModal(id, clickedHotspot);
                break;
            case "job":
                window.krpanoObj.call(
                    "job_set_as_visited('" + name.replace("_text", "_hitarea") + "');"
                );
                if (!webVRActive) handleOpenJobModal(id);
                else handleOpenVrInfoModal(id, clickedHotspot);
                break;
            case "video":
                window.krpanoObj.call(
                    "video_set_as_visited('" + name.replace("_text", "_hitarea") + "');"
                );
                if (!webVRActive) handleOpenVideoModal(id);
                else handleOpenVrInfoModal(id, clickedHotspot);
                break;
            case "exit_vr":
                handleExitWebVR();
                break;
            case "next_vr":
                handleNextPano(id);
                break;
            case "prev_vr":
                handlePrevPano(id);
                break;
            case "close_modal":
                if (webVRActive) handleCloseAllVrInfoModals(id);
                break;
            default:
                break;
        }
    };

    window.togglePanoTitle = (status) => {
        setShowPanoTitle(status == "true");

        if (status == "false") {
            setShowPanoHelp(false);

            var exdays = 1;
            var d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

            setCookie("panoHelp", "1", {
                path: "/",
                expires: d,
            });
        }
    };

    window.setModalFollowLookat = (modalName) => {
        const smoothing = 0.1;
        // const parentAth = krpanoObj.get(`hotspot[${modalName}]`)?.parentAth;
        // const parentAtv = krpanoObj.get(`hotspot[${modalName}]`)?.parentAtv;
        const layers = [
            modalName,
            `${modalName}_container`,
            `${modalName}_close`,
            `${modalName}_next`,
            `${modalName}_prev`,
            `${modalName}_image`,
            `${modalName}_video`,
            `${modalName}_play`,
            `${modalName}_videoclose`,
            `${modalName}_videooverlay`,
            `${modalName}_videoprogresscontainer`,
            `${modalName}_videoprogresstime`,
            `${modalName}_videoprogresseekhandle`,
            `${modalName}_videoprogresseekbackground`,
            `${modalName}_videoprogresseekforeground`,
        ];
        layers.forEach((layer) => {
            // Modals always to about eye-level

            // const hotspotAth = krpanoObj.get(`hotspot[${layer}].ath`);
            const hotspotAtv = krpanoObj.get(`hotspot[${layer}].atv`);
            // const offsetAth = ((krpanoObj.view.hlookat + 360000000 - parentAth) % 360) - 180;
            // const offsetAtv = krpanoObj.view.vlookat * 0.1;
            // console.log(offsetAth);
            if (krpanoObj.get(`hotspot[${layer}]`)) {
                // const lerpedH = lerp(hotspotAth, parentAth + offsetAth, smoothing);
                const lerpedV = lerp(hotspotAtv, 0, smoothing);
                // krpanoObj.set(`hotspot[${layer}].ath`, lerpedH);
                krpanoObj.set(`hotspot[${layer}].atv`, lerpedV);
            }
        });

        const dots = window.krpanoObj.hotspot
            .getArray()
            .filter((x) => x.name.includes(`${modalName}_dot_`));
        dots.forEach((dot) => {
            const lerpedV = lerp(dot.atv, 0, smoothing);
            dot.atv = lerpedV;
        });
    };
    window.setVrModalActivePage = (modalName, newPageIndex) => {
        // Set active page
        const newPageContent = window.krpanoObj.get(
            `hotspot[${modalName}].pagecontent${newPageIndex}`
        );
        if (newPageContent) {
            window.krpanoObj.call(
                `set(data[modal_content].content, get(hotspot[${modalName}].pagecontent${newPageIndex}))`
            );
            window.krpanoObj.call(
                `set(hotspot[${modalName}_container].html, get(data[modal_content].content))`
            );
        }

        // Set active dot
        const allPageDots = window.krpanoObj.hotspot
            .getArray()
            .filter((x) => x.name.includes(`${modalName}_dot_`));
        allPageDots.forEach((pageDot) => {
            if (pageDot.name === `${modalName}_dot_${newPageIndex}`) pageDot.bgcolor = 0xe14141;
            else pageDot.bgcolor = 0xd9d9d9;
        });
    };
    window.toggleVrModalPageDots = (modalName, opactiy) => {
        const allPageDots = window.krpanoObj.hotspot
            .getArray()
            .filter((x) => x.name.includes(`${modalName}_dot_`));
        allPageDots.forEach((pageDot) => {
            if (opactiy === "1") setTimeout(() => (pageDot.alpha = opactiy), 300);
            else pageDot.alpha = opactiy;
        });
    };
    //

    // VISITED HOTSPOTS
    const updateVisitedHotspots = (type, id, name) => {
        // if (!includes(visitedHotspots, hotspotId)) {
        setVisitedHotspots([
            ...visitedHotspots,
            {
                type: type,
                id: id,
                name: name,
            },
        ]);
        // }
    };
    //

    // PANO
    const loadPanoData = async (panoId) => {
        setLoading(true);

        var result = await request
            .get("/api/pano/data")
            .query({
                id: panoId,
            })
            .set("Accept", "application/json, text/javascript");

        setLoading(false);
        setPanoData(result.body);
    };

    const loadpano = async (e, panoId) => {
        if (e) e.preventDefault();

        if (!panoId) return;
        let pano = find(panos, ["id", parseInt(panoId)]);

        var panodata = await loadPanoData(panoId);

        setLoading(false);
        setActivePano(pano);
        setActivePanoIndex(findIndex(panos, pano));
        setShowPanoTitle(true);
        setThumbNavOpened(false);

        if (window.krpanoObj && pano) {
            // console.log(`Opening pano with id ${panoId}`);
            window.krpanoObj.call(
                "loadscene('" + pano.panoData.attributes.name + "', null, MERGE, BLEND(0.5));"
            );
            if (webVRActive) {
                window.krpanoObj.call("webvr_onentervr();");
                const nextPano = getNextPano(panoId);
                const prevPano = getPrevPano(panoId);
                setTimeout(() => {
                    addControlHotspot(
                        "next_vr",
                        `Volgende locatie: ${nextPano.title}`,
                        "nextvr_hs_style",
                        65,
                        0,
                        "next_vr",
                        nextPano.id
                    );
                    addControlHotspot(
                        "prev_vr",
                        `Vorige locatie: ${prevPano.title}`,
                        "prevvr_hs_style",
                        75,
                        0,
                        "prev_vr",
                        prevPano.id
                    );
                }, 600);
            } else {
                history.push({
                    pathname:
                        (isEmbed ? "/embed" : "") + `/virtual-tour/${vtour.slug}/${pano.slug}`,
                    search: location.search,
                });

                if (vtOnly) {
                    window.krpanoObj.call("loop(hotspot.count GT 0, removehotspot(0) );");
                } else {
                    // Check all visited hotspots
                    setTimeout(function () {
                        visitedHotspots.forEach((hotspot) => {
                            switch (hotspot.type) {
                                case "navigateTo":
                                    window.krpanoObj.call(
                                        "default_set_as_visited('" + hotspot.name + "');"
                                    );
                                    break;
                                case "information":
                                    window.krpanoObj.call(
                                        "info_set_as_visited('" + hotspot.name + "');"
                                    );
                                    break;
                                case "informationSmall":
                                    window.krpanoObj.call(
                                        "info_set_as_visited('" + hotspot.name + "');"
                                    );
                                    break;
                                case "job":
                                    window.krpanoObj.call(
                                        "job_set_as_visited('" + hotspot.name + "');"
                                    );
                                    break;
                                case "video":
                                    window.krpanoObj.call(
                                        "video_set_as_visited('" + hotspot.name + "');"
                                    );
                                    break;
                                default:
                                    break;
                            }
                        });
                    }, 1000);
                }
            }

            // Send GA Pageview on pano load
            if (typeof ga === "function") {
                ga("send", "pageview", location.pathname);
            }
        }
    };
    //

    //THUMB NAV MODAL
    const handleOpenThumbNav = (e) => {
        if (e) e.preventDefault();
        setThumbNavOpened(true);
    };
    const handleCloseThumbNav = () => {
        setThumbNavOpened(false);
    };
    //

    //INFO MODAL
    const handleOpenInfoModal = (id) => {
        if (panoData && panoData.hotspots) {
            let hsData = find(panoData.hotspots, ["id", parseInt(id)]);
            setHotspotData(hsData);
        }
        setInfoModalOpened(true);
    };
    const handleCloseInfoModal = () => {
        setInfoModalOpened(false);
        setHotspotData(null);
    };
    // VR
    const handleOpenVrInfoModal = (id, originalHotpsot) => {
        if (panoData && panoData.hotspots) {
            handleCloseAllVrInfoModals();

            const modalName = `vr_info_modal_${id}`;
            let hsData = find(panoData.hotspots, ["id", parseInt(id)]);

            // console.log(hsData);
            if (hsData && !hsData.text && hsData.type === "video" && !hsData.videoFile) return;
            const modal = window.krpanoObj.addhotspot(modalName);
            modal.loadstyle("info_hs_vr_modal_style");
            modal.name = modalName;
            modal.vrinfomodal = "yes";
            modal.actionid = id;
            modal.actiontype = "vr_info_modal_close";
            modal.ath = originalHotpsot.ath;
            modal.atv = originalHotpsot.atv;
            modal.parentAth = originalHotpsot.ath;
            modal.parentAtv = originalHotpsot.atv;

            let pages = [];
            let paragraphs = [];
            if (hsData.text) {
                paragraphs = hsData.text
                    .replaceAll("</p>", "</p>###")
                    .replaceAll("\r", "")
                    .replaceAll("\n", "")
                    .split("###")
                    .filter((line) => line);

                paragraphs.forEach((p, index) => {
                    if (index % 2 === 0) {
                        pages.push([paragraphs[index], paragraphs[index + 1]]);
                    }
                });
            }

            const hasMedia = hsData.image || hsData.videoFile;
            let maxWith = hasMedia ? 1000 : 500;
            let tallestPageHeight = 0;

            modal.pages = pages;

            // Content
            pages.forEach((page, index) => {
                let pageContent = "";
                pageContent += `<div style="font-family: 'PT Serif'; text-decoration: none; width: ${maxWith}px; height: 100%; padding: 48px; color: #555555; font-size: 16px; line-height: 24px; font-weight: 400;">`;

                // Table
                pageContent += `<table>`;
                pageContent += `<tr>`;

                // Text
                if (hsData.text)
                    pageContent += createVrModalTextPage(page, index, hsData, hasMedia);

                // Image
                if (hsData.image) {
                    const imageAspectRatio = Number(hsData.imageHeight) / Number(hsData.imageWidth);
                    const imageWidth = 500 - 16 - 48;
                    const imageHeight = imageAspectRatio * imageWidth;
                    pageContent += `<td style="padding-left: 16px">`;
                    pageContent += `<img src="${hsData.image}" style="width: ${imageWidth}px; height: ${imageHeight}px;" />`;
                    pageContent += `</td>`;
                    modal.imagew = imageWidth;
                    modal.imageh = imageHeight;
                    modal.imageurl = hsData.image;
                }

                // Video
                if (hsData.videoFile) {
                    // 16 / 9
                    const videoWidth = 500 - 16 - 48;
                    const videoHeight = 245;
                    pageContent += `<td style="padding-left: 16px">`;
                    pageContent += `<img style="width: ${videoWidth}px; height: ${videoHeight}px;" />`;
                    pageContent += `</td>`;
                    modal.videow = videoWidth;
                    modal.videoh = videoHeight;
                    modal.videourl = hsData.videoFile;
                }

                pageContent += `</tr>`;
                pageContent += `</table>`;

                // Pagination
                if (pages.length > 1) {
                    const dot = window.krpanoObj.addhotspot(`${modalName}_dot_${index}`);
                    dot.loadstyle("modal_dot_hs_style");
                    dot.name = `${modalName}_dot_${index}`;
                    dot.ath = originalHotpsot.ath;
                    dot.atv = originalHotpsot.atv;
                    dot.depth = 4003;
                    dot.scale = 0.8;

                    if (pages.length % 2 !== 0)
                        dot.ox = 16 * 0.6 * (index + 1 - Math.ceil(pages.length / 2));
                    else dot.ox = 16 * 0.6 * (index + 1 - Math.ceil(pages.length / 2)) - 8;

                    pageContent += `<table style="margin: 56px auto 0 auto;">`;
                    pageContent += `<tr>`;
                    pages.forEach((page, index) => {
                        pageContent += `<td style="padding-inline: 4px;">`;
                        pageContent += `<div style="background: ${
                            index === 0 ? "#E14141" : "#D9D9D9"
                        }; height: 8px; width: 8px; border-radius: 9999px;"></div>`;
                        pageContent += `</td>`;
                    });
                    pageContent += `</tr>`;
                    pageContent += `</table>`;
                }

                pageContent += `</div>`;

                // console.log(pageContent);
                const pageHeight = calculateElementHeight(pageContent, maxWith);
                if (pageHeight > tallestPageHeight) tallestPageHeight = pageHeight;
                modal[`pagecontent${index}`] = pageContent;
            });

            if (pages.length === 0) {
                let pageContent = "";
                maxWith = 500;
                pageContent += `<div style="font-family: 'PT Serif'; text-decoration: none; width: ${maxWith}px; height: 100%; padding: 48px; color: #555555; font-size: 16px; line-height: 24px; font-weight: 400;">`;

                // Table
                pageContent += `<table>`;
                pageContent += `<tr>`;

                // Image
                if (hsData.image) {
                    const imageAspectRatio = Number(hsData.imageHeight) / Number(hsData.imageWidth);
                    const imageWidth = 500 - 48 - 48;
                    const imageHeight = imageAspectRatio * imageWidth;
                    pageContent += `<td>`;
                    // font-family: 'PT Sans';
                    pageContent += `<h1 style="font-family: 'Trebuchet MS'; font-size: 28px; line-height: 36px; font-weight: 700; color: #303030; margin-bottom: 32px;">${hsData.title}</h1>`;
                    pageContent += `<img src="${hsData.image}" style="width: ${imageWidth}px; height: ${imageHeight}px;" />`;
                    pageContent += `</td>`;
                    modal.imagew = imageWidth;
                    modal.imageh = imageHeight;
                    modal.imageurl = hsData.image;
                }

                // Video
                if (hsData.videoFile) {
                    // 16 / 9
                    const videoWidth = 500 - 48 - 48;
                    const videoHeight = 227;
                    pageContent += `<td>`;
                    // font-family: 'PT Sans';
                    pageContent += `<h1 style="font-family: 'Trebuchet MS'; font-size: 28px; line-height: 36px; font-weight: 700; color: #303030; margin-bottom: 32px;">${hsData.title}</h1>`;
                    pageContent += `<img style="width: ${videoWidth}px; height: ${videoHeight}px;" />`;
                    pageContent += `</td>`;
                    modal.videow = videoWidth;
                    modal.videoh = videoHeight;
                    modal.videourl = hsData.videoFile;
                    // modal.videourl = "/krpano-1.20.11/partials/bunny.mp4";
                }

                pageContent += `</tr>`;
                pageContent += `</table>`;
                pageContent += `</div>`;

                const pageHeight = calculateElementHeight(pageContent, maxWith);
                if (pageHeight > tallestPageHeight) tallestPageHeight = pageHeight;
                modal[`pagecontent0`] = pageContent;
            }

            // console.log(modal[`pagecontent0`]);

            modal.maxwidth = maxWith;
            modal.modalheight = tallestPageHeight;

            pages.forEach((page, index) => {
                const dot = window.krpanoObj.get(`hotspot['${modalName}_dot_${index}']`);
                if (dot) {
                    window.krpanoObj.call(`set_oy_of_dot(${dot.name}, calc(${modal.modalheight}))`);
                    if (index === 0) dot.bgcolor = 0xe14141;
                }
            });

            // Modal follows view
            window.krpanoObj.call(
                `set(
                    global.events[modal_follow_event].onviewchange,
                    modal_follow_event_onviewchange('${modalName}')
                );`
            );
        }
    };
    const createVrModalTextPage = (paragraphs, index, hsData, hasMedia) => {
        let content = "";
        content += `<td style="${hasMedia ? "padding-right: 16px;" : ""}">`;
        if (index === 0)
            // font-family: 'PT Sans'; - Font family struggles with punctuation in VR
            content += `<h1 style="font-family: 'Trebuchet MS'; font-size: 28px; line-height: 36px; font-weight: 700; color: #303030; margin-bottom: 32px;">${hsData.title}</h1>`;
        if (paragraphs[0])
            content += `${paragraphs[0]
                .replace(/<a.[^>]+>/g, "<span>")
                .replace("</a>", "</span>")
                .replace("&nbsp;", " ")}`;
        if (paragraphs[1])
            content += `${paragraphs[1]
                .replace(/<a.[^>]+>/g, "<span>")
                .replace("</a>", "</span>")
                .replace("&nbsp;", " ")}`;
        else content += `<p></p>`;
        content += `</td>`;
        return content;
    };
    const handleCloseAllVrInfoModals = () => {
        const allCurrentHotspots = window.krpanoObj.get("hotspot").getArray();
        const allVrInfoModalSpots = allCurrentHotspots.filter((hs) =>
            hs.name.includes("vr_info_modal")
        );
        allVrInfoModalSpots.forEach((hs) => window.krpanoObj.removehotspot(hs.name));
    };
    //

    //INFO SMALL MODAL
    const handleOpenInfoSmallModal = (id) => {
        if (panoData && panoData.hotspots) {
            let hsData = find(panoData.hotspots, ["id", parseInt(id)]);
            setHotspotData(hsData);
        }
        setInfoSmallModalOpened(true);
    };
    const handleCloseInfoSmallModal = () => {
        setInfoSmallModalOpened(false);
        setHotspotData(null);
    };
    //

    //JOB MODAL
    const handleOpenJobModal = (id) => {
        if (panoData && panoData.hotspots) {
            let hsData = find(panoData.hotspots, ["id", parseInt(id)]);
            setHotspotData(hsData);
        }
        setJobModalOpened(true);
    };
    const handleCloseJobModal = () => {
        setJobModalOpened(false);
        setHotspotData(null);
    };
    //

    //VIDEO MODAL
    const handleOpenVideoModal = (id) => {
        if (panoData && panoData.hotspots) {
            let hsData = find(panoData.hotspots, ["id", parseInt(id)]);
            setHotspotData(hsData);
        }
        setVideoModalOpened(true);
    };
    const handleCloseVideoModal = () => {
        setVideoModalOpened(false);
        setHotspotData(null);
    };
    //

    //PANO INFO MODAL
    const handleOpenPanoModal = (e) => {
        if (e) e.preventDefault();
        setPanoModalOpened(true);
    };
    const handleClosePanoModal = () => {
        setPanoModalOpened(false);
    };
    //

    //WEB VR
    const addControlHotspot = (name, label, style, atv, ath, actionType, actionId) => {
        // Remove old control hotspot
        // const oldToRemove = window.krpanoObj.hotspot
        //     .getArray()
        //     .filter((hs) => hs.name.includes(name));
        // oldToRemove.forEach((hs) => window.krpanoObj.removehotspot(hs.name));

        // Create control hotspot
        let spot = window.krpanoObj.addhotspot(name);
        spot.loadstyle(style);
        spot.text = label;
        spot.atv = atv;
        spot.ath = ath;
        spot.actiontype = actionType;
        spot.actionid = actionId;
        spot.nextvrspot = "yes";
    };

    const getNextPano = (activeId = null) => {
        let nextPano = null;
        if (activeId) {
            const activePanoInd = panos.indexOf(panos.find((x) => x.id === Number(activeId)));
            if (activePanoInd + 1 < panos.length) nextPano = panos[activePanoInd + 1];
            else nextPano = panos[0];
        } else {
            if (activePanoIndex + 1 < panos.length) nextPano = panos[activePanoIndex + 1];
            else nextPano = panos[0];
        }
        return nextPano;
    };

    const getPrevPano = (activeId = null) => {
        let prevPano = null;
        if (activeId) {
            const activePanoInd = panos.indexOf(panos.find((x) => x.id === Number(activeId)));
            if (activePanoInd > 0) prevPano = panos[activePanoInd - 1];
            else prevPano = panos[panos.length - 1];
        } else {
            if (activePanoIndex > 0) prevPano = panos[activePanoIndex - 1];
            else prevPano = panos[panos.length - 1];
        }
        return prevPano;
    };

    const handleStartWebVR = (e) => {
        if (e) e.preventDefault();
        setWebVRActive(true);
        window.krpanoObj.call("webvr_onentervr();");
        window.krpanoObj.call("webvr.enterVR();");

        const nextPano = getNextPano();
        const prevPano = getPrevPano();
        addControlHotspot(
            "next_vr",
            `Volgende locatie: ${nextPano.title}`,
            "nextvr_hs_style",
            65,
            0,
            "next_vr",
            nextPano.id
        );
        addControlHotspot(
            "prev_vr",
            `Vorige locatie: ${prevPano.title}`,
            "prevvr_hs_style",
            75,
            0,
            "prev_vr",
            prevPano.id
        );
    };
    const handleExitWebVR = () => {
        window.krpanoObj.call("webvr.exitVR();");
        window.krpanoObj.call("webvr_onexitvr();");
        setWebVRActive(false);
    };
    const handleNextPano = (nextPanoId) => {
        const nextPano = panos.find((p) => p.id === Number(nextPanoId));
        loadpano(null, nextPano.id);
    };
    const handlePrevPano = (prevPanoId) => {
        const prevPano = panos.find((p) => p.id === Number(prevPanoId));
        loadpano(null, prevPano.id);
    };
    window.setVrReadyStatus = (vrStatus) => {
        setIsWebVRCapable(vrStatus);
    };
    //

    return (
        <div className={styles.krpanoWrapper}>
            <div
                id="krpano"
                className={[
                    styles.krpano,
                    isWebVRCapable && webVRActive ? styles.krpano__webvr : "",
                ].join(" ")}
            />

            <span className={styles.krpanoLoader}>
                <span></span>
            </span>

            {vtour && vtour.logo && !isEmbed && !vtOnly && (
                <img src={vtour.logo} className={styles.panoLogo} />
            )}

            {!vtOnly && <span className={styles.panoActionsBackdrop} />}

            {!vtOnly && (
                <div
                    className={[
                        styles.panoTitle,
                        activePano && activePano.title && showPanoTitle
                            ? styles.panoTitle__visible
                            : "",
                    ].join(" ")}
                >
                    {activePano && activePano.title}
                </div>
            )}

            {panoData && (panoData.pano.infoTitle || panoData.pano.infoText) && !vtOnly && (
                <a href="#" className={styles.panoInfo} onClick={(e) => handleOpenPanoModal(e)}>
                    Info
                </a>
            )}

            {!vtOnly && (
                <div
                    className={[
                        styles.panoTitleBottom,
                        (activePano && activePano.title && !showPanoTitle) || showPanoNavTitle
                            ? styles.panoTitleBottom__visible
                            : "",
                        showPanoNavTitle ? styles.panoTitleBottom__navHover : "",
                        panoData && (panoData.pano.infoTitle || panoData.pano.infoText)
                            ? styles.panoTitleBottom__hasInfo
                            : "",
                    ].join(" ")}
                >
                    {activePano && !showPanoNavTitle && activePano.title}
                    {showPanoNavTitle && showPanoNavTitle}
                </div>
            )}

            {!vtOnly && (
                <div
                    className={[styles.panoHelp, showPanoHelp ? styles.panoHelp__visible : ""].join(
                        " "
                    )}
                >
                    <img src="/img/icon-mouse.svg" className={styles.panoHelpDesktop} />
                    <span className={styles.panoHelpDesktop}>
                        {window.tstrings["Click & drag to explore"]}
                    </span>
                    <img src="/img/icon-tap-drag.svg" className={styles.panoHelpMobile} />
                    <span className={styles.panoHelpMobile}>
                        {window.tstrings["Tap & drag to explore"]}
                    </span>
                </div>
            )}

            {!vtOnly && (
                <div className={styles.panoNav}>
                    {panos &&
                        panos.map((pano, idx) => (
                            <a
                                href="#"
                                key={pano.id}
                                onClick={(e) => loadpano(e, pano.id)}
                                onMouseEnter={() => setShowPanoNavTitle(pano.title)}
                                onMouseLeave={() => setShowPanoNavTitle(null)}
                                className={[
                                    styles.panoNavItem,
                                    activePano && activePano.id == pano.id
                                        ? styles.panoNavActive
                                        : "",
                                ].join(" ")}
                            >
                                <span>{pano.title}</span>
                            </a>
                        ))}
                </div>
            )}

            {vtour &&
                (vtour.social.facebook || vtour.social.instagram || vtour.social.linkedin) &&
                !isEmbed &&
                !vtOnly && (
                    <div className={styles.panoSocial}>
                        {vtour.social.facebook && (
                            <a
                                href={vtour.social.facebook}
                                className={[
                                    styles.panoSocialItem,
                                    styles.panoSocialItem__facebook,
                                ].join(" ")}
                                target="_blank"
                                rel="noopener"
                            >
                                <img src={"/img/icon-pano-facebook.svg"} />
                            </a>
                        )}

                        {vtour.social.linkedin && (
                            <a
                                href={vtour.social.linkedin}
                                className={[
                                    styles.panoSocialItem,
                                    styles.panoSocialItem__linkedin,
                                ].join(" ")}
                                target="_blank"
                                rel="noopener"
                            >
                                <img src={"/img/icon-pano-linkedin.svg"} />
                            </a>
                        )}

                        {vtour.social.instagram && (
                            <a
                                href={vtour.social.instagram}
                                className={[
                                    styles.panoSocialItem,
                                    styles.panoSocialItem__instagram,
                                ].join(" ")}
                                target="_blank"
                                rel="noopener"
                            >
                                <img src={"/img/icon-pano-instagram.svg"} />
                            </a>
                        )}
                    </div>
                )}

            {!vtOnly && (
                <div className={styles.panoActions}>
                    {isWebVRCapable && (
                        <a
                            href="#"
                            className={styles.panoWebVRBtn}
                            onClick={(e) => handleStartWebVR(e)}
                        >
                            <img src={"/img/icon-pano-webvr.svg"} />
                        </a>
                    )}

                    {vtour && vtour.website && !isEmbed && (
                        <a
                            href={vtour.website}
                            className={styles.panoWebsiteBtn}
                            target="_blank"
                            rel="noopener"
                        >
                            <img src={"/img/icon-pano-website.svg"} />
                        </a>
                    )}

                    <a
                        href="#"
                        className={styles.panoThumbBtn}
                        onClick={(e) => handleOpenThumbNav(e)}
                    >
                        <img src={"/img/icon-pano-thumbs.svg"} />
                    </a>
                </div>
            )}

            <a href={"https://www.poppr.be"} className={styles.panoCredits} _target="_blank">
                Powered py Poppr
            </a>

            <Modal
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.75)",
                        zIndex: 1000,
                    },
                    content: {
                        top: "auto",
                        right: "0",
                        left: "0",
                        bottom: "0",
                        backgroundColor: "transparent",
                        border: "none",
                    },
                }}
                closeTimeoutMS={200}
                ariaHideApp={false}
                isOpen={thumbNavOpened}
                onRequestClose={handleCloseThumbNav}
            >
                <button onClick={handleCloseThumbNav} className={styles.thumbModalCloseButton}>
                    <span>Sluiten</span>
                    <img src={"/img/icon-pano-close-white.svg"} />
                </button>
                <div className={styles.thumbNavSlider}>
                    <Swiper getSwiper={updateThumbSwiper} {...thumbNavSiderParams}>
                        {panos &&
                            panos.map((pano, idx) => (
                                <a
                                    href="#"
                                    key={idx}
                                    onClick={(e) => loadpano(e, pano.id)}
                                    className={[
                                        styles.thumbNavSlide,
                                        activePano && activePano.id == pano.id
                                            ? styles.thumbNavSlide__active
                                            : "",
                                    ].join(" ")}
                                >
                                    <img src={pano.thumb} />
                                    <span>{pano.title}</span>
                                </a>
                            ))}
                    </Swiper>
                </div>
            </Modal>

            <Modal
                style={{
                    overlay: {
                        backgroundColor: "rgba(255, 255, 255, 0.98)",
                        zIndex: 1000,
                    },
                    content: {
                        top: "0",
                        right: "0",
                        left: "0",
                        bottom: "0",
                        backgroundColor: "transparent",
                        border: "none",
                    },
                }}
                closeTimeoutMS={200}
                ariaHideApp={false}
                isOpen={infoModalOpened}
                onRequestClose={handleCloseInfoModal}
            >
                <button onClick={handleCloseInfoModal} className={styles.modalCloseButton}>
                    <img src={"/img/icon-pano-close.svg"} />
                </button>
                {hotspotData &&
                    (hotspotData.title || hotspotData.text) &&
                    hotspotData.type == "information" && (
                        <div
                            className={[styles.modalContent, styles.modalContent__hotspotInfo].join(
                                " "
                            )}
                        >
                            <h1>{hotspotData.title}</h1>
                            {hotspotData.image && (
                                <figure>
                                    <img src={hotspotData.image} alt="" />
                                </figure>
                            )}
                            <div
                                dangerouslySetInnerHTML={{
                                    __html:
                                        hotspotData.text &&
                                        hotspotData.text.replace(/(<? *script)/gi, "illegalscript"),
                                }}
                            />
                        </div>
                    )}
            </Modal>

            <Modal
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.74)",
                        zIndex: 1000,
                    },
                    content: {
                        display: "flex",
                        alignItems: "center",
                        top: "0",
                        right: "0",
                        left: "0",
                        bottom: "0",
                        backgroundColor: "transparent",
                        border: "none",
                        overflow: "auto",
                        WebkitOverflowScrolling: "touch",
                    },
                }}
                closeTimeoutMS={200}
                ariaHideApp={false}
                isOpen={infoSmallModalOpened}
                onRequestClose={handleCloseInfoSmallModal}
            >
                {hotspotData &&
                    (hotspotData.title || hotspotData.text) &&
                    hotspotData.type == "informationSmall" && (
                        <div
                            className={[
                                styles.modalContent,
                                styles.modalContent__hotspotInfoSmall,
                            ].join(" ")}
                        >
                            <h1>{hotspotData.title}</h1>
                            <button
                                onClick={handleCloseInfoSmallModal}
                                className={[
                                    styles.modalCloseButton,
                                    styles.modalCloseButtonInfoSmall,
                                ].join(" ")}
                            >
                                <img src={"/img/icon-pano-close.svg"} />
                            </button>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html:
                                        hotspotData.text &&
                                        hotspotData.text.replace(/(<? *script)/gi, "illegalscript"),
                                }}
                            />
                            {hotspotData.link && (
                                <a
                                    href={hotspotData.link}
                                    className={styles.jobModalLink}
                                    target="_blank"
                                >
                                    {hotspotData.linkText}
                                </a>
                            )}
                        </div>
                    )}
            </Modal>

            <Modal
                style={{
                    overlay: {
                        backgroundColor: "rgba(255, 255, 255, 0.98)",
                        zIndex: 1000,
                    },
                    content: {
                        top: "0",
                        right: "0",
                        left: "0",
                        bottom: "0",
                        backgroundColor: "transparent",
                        border: "none",
                    },
                }}
                closeTimeoutMS={200}
                ariaHideApp={false}
                isOpen={videoModalOpened}
                onRequestClose={handleCloseVideoModal}
            >
                <button onClick={handleCloseVideoModal} className={styles.modalCloseButton}>
                    <img src={"/img/icon-pano-close.svg"} />
                </button>
                {hotspotData &&
                    (hotspotData.title || hotspotData.text) &&
                    hotspotData.type == "video" && (
                        <div
                            className={[
                                styles.modalContent,
                                styles.modalContent__hotspotVideo,
                            ].join(" ")}
                        >
                            {hotspotData.video && (
                                <div className={styles.modalContent__hotspotVideo_vid}>
                                    <iframe
                                        src={
                                            "https://www.youtube.com/embed/" +
                                            hotspotData.video +
                                            "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
                                        }
                                        frameBorder="0"
                                        scrolling="no"
                                        marginHeight="0"
                                        marginWidth="0"
                                        width="100%"
                                        height="100%"
                                        type="text/html"
                                    ></iframe>
                                </div>
                            )}
                            <h1>{hotspotData.title}</h1>
                            <div
                                className={styles.modalContent__hotspotVideo_txt}
                                dangerouslySetInnerHTML={{
                                    __html:
                                        hotspotData.text &&
                                        hotspotData.text.replace(/(<? *script)/gi, "illegalscript"),
                                }}
                            />
                        </div>
                    )}
            </Modal>

            <Modal
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.74)",
                        zIndex: 1000,
                    },
                    content: {
                        display: "flex",
                        alignItems: "center",
                        top: "0",
                        right: "0",
                        left: "0",
                        bottom: "0",
                        backgroundColor: "transparent",
                        border: "none",
                        overflow: "auto",
                        WebkitOverflowScrolling: "touch",
                    },
                }}
                closeTimeoutMS={200}
                ariaHideApp={false}
                isOpen={jobModalOpened}
                onRequestClose={handleCloseJobModal}
            >
                {hotspotData &&
                    (hotspotData.title || hotspotData.text) &&
                    hotspotData.type == "job" && (
                        <div
                            className={[styles.modalContent, styles.modalContent__hotspotJob].join(
                                " "
                            )}
                        >
                            <h1>{hotspotData.title}</h1>
                            <button
                                onClick={handleCloseJobModal}
                                className={[
                                    styles.modalCloseButton,
                                    styles.modalCloseButtonJob,
                                ].join(" ")}
                            >
                                <img src={"/img/icon-pano-close.svg"} />
                            </button>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html:
                                        hotspotData.text &&
                                        hotspotData.text.replace(/(<? *script)/gi, "illegalscript"),
                                }}
                            />
                            {hotspotData.link && (
                                <a
                                    href={hotspotData.link}
                                    className={styles.jobModalLink}
                                    target="_blank"
                                >
                                    {hotspotData.linkText}
                                </a>
                            )}
                        </div>
                    )}
            </Modal>

            <Modal
                style={{
                    overlay: {
                        backgroundColor: "rgba(255, 255, 255, 0.98)",
                        zIndex: 1000,
                    },
                    content: {
                        top: "0",
                        right: "0",
                        left: "0",
                        bottom: "0",
                        backgroundColor: "transparent",
                        border: "none",
                    },
                }}
                closeTimeoutMS={200}
                ariaHideApp={false}
                isOpen={panoModalOpened}
                onRequestClose={handleClosePanoModal}
            >
                <button onClick={handleClosePanoModal} className={styles.modalCloseButton}>
                    <img src={"/img/icon-pano-close.svg"} />
                </button>
                {panoData && panoData.pano && (
                    <div className={[styles.modalContent, styles.modalContent__panoInfo].join(" ")}>
                        <h1>{panoData.pano.infoTitle}</h1>
                        <div
                            dangerouslySetInnerHTML={{
                                __html:
                                    panoData.pano.infoText &&
                                    panoData.pano.infoText.replace(
                                        /(<? *script)/gi,
                                        "illegalscript"
                                    ),
                            }}
                        />
                    </div>
                )}
            </Modal>
        </div>
    );
};

export { Krpano };

// export default withRouter(Krpano);
